import { FC } from 'react';
import Skeleton from '../presentational/skeleton';

const SkeletonGuildDetailsPage: FC<any> = () => {
  return (
    <div style={{ position: 'relative' }}>
      <div className="slds-grid slds-wrap slds-grid--pull-padded">
        <div className="slds-size--8-of-12 slds-max-small-size--1-of-1 slds-max-medium-size--1-of-1 slds-p-horizontal--small">
          <Skeleton height={43} />
          <Skeleton variant="item" height={95} animate />
        </div>
        <div className="slds-size--4-of-12 slds-max-small-size--1-of-1 slds-max-medium-size--1-of-1 slds-p-horizontal--small">
          <Skeleton height={43} />
          <Skeleton variant="item" height={95} animate />
        </div>
      </div>

      <div style={{ marginTop: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
          <Skeleton width={150} height={32} />
          <Skeleton width={188} height={32} />
        </div>
        <div style={{ marginBottom: 32 }}>
          <Skeleton height={31} />
          <Skeleton variant="item" height={564} animate />
        </div>
        <div style={{ marginBottom: 32 }}>
          <Skeleton height={36} />
          <Skeleton variant="item" height={126} animate />
        </div>
        <div style={{ marginBottom: 32 }}>
          <Skeleton height={36} />
          <Skeleton variant="item" height={126} animate />
        </div>
        <div style={{ marginBottom: 32 }}>
          <Skeleton height={36} />
          <Skeleton variant="item" height={126} animate />
        </div>
        <div style={{ marginBottom: 32 }}>
          <Skeleton height={36} />
          <Skeleton variant="item" height={126} animate />
        </div>
        <div style={{ marginBottom: 32 }}>
          <Skeleton height={36} />
          <Skeleton variant="item" height={126} animate />
        </div>
      </div>
    </div>
  );
};

export default SkeletonGuildDetailsPage;

